import React, { Component, useEffect, useRef } from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, StatusBar, Platform } from 'react-native';
import { ImageComp } from '../../components/Image/Image';
import { ERROR_500 } from '../../assets';
import { setRenderAdminModal, setServiceStatus } from '../../Redux/Reducers/appConfigReducer';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import { DEVICEREGISTRATIONENABLED, ISINROOMTAB } from '../../config/Constant';
import { AdminPanel } from '../AdminPanel';
import CustomPressable from '../../components/customPressable/customPressable';
// import crashlytics from '@react-native-firebase/crashlytics';

let crashlytics;
if (Platform.OS !== 'web') {
  const moduleName = '@react-native-firebase/crashlytics';
  import(/* webpackIgnore: true */ moduleName)
    .then(module => {
      crashlytics = module.default;
    })
    .catch(() => { });
}

const ErrorBoundaryComp = ({ handleRetry, errorMessage, errorDescription }) => {
  
  const getStyles = useCssStyle();
  const dispatch = useDispatch();

  const { renderAdminModal } = useSelector(state => state.appConfigSlice);

  const tapCountRef = useRef(0);
  const tapTimerRef = useRef(null);


  const handleDeviceAdminPage = () => {

    if (!ISINROOMTAB && !DEVICEREGISTRATIONENABLED) {
      return;
    }

    tapCountRef.current += 1;

    // always clear any existing timer
    if (tapTimerRef.current) {
      clearTimeout(tapTimerRef.current);
    }

    // if user hits 5 taps, trigger the modal and reset
    if (tapCountRef.current === 5) {
      tapCountRef.current = 0;
      dispatch(setRenderAdminModal(true))
    }

    // otherwise, reset tap count after 2 seconds
    tapTimerRef.current = setTimeout(() => {
      tapCountRef.current = 0;
    }, 2000);
  }


  useEffect(() => {
    if (errorDescription && crashlytics && crashlytics().isCrashlyticsCollectionEnabled) {
      crashlytics().log({ status: "failed", error: errorDescription });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorDescription]);

  return (
    <>
      <StatusBar translucent backgroundColor={"transparent"} />
      <View style={getStyles(['errorContainer'])}>
        <CustomPressable onPress={handleDeviceAdminPage}><Text style={getStyles(['errorTitle'])}>Service Unavailable</Text></CustomPressable>
        <ImageComp
          source={ERROR_500}
          style={getStyles(['errorImage'])}
        />
        <Text style={getStyles(['errorMessage'])}>{errorMessage || (errorDescription ? "Something went wrong" : "Service is currently not available at this time.")}</Text>
        <TouchableOpacity onPress={handleRetry} style={getStyles(['errorRetryButton'])}>
          <Text style={getStyles(['errorRetryText'])}>
            Tap <Text style={getStyles(['errorHereText'])}>here</Text> to refresh or try again later.
          </Text>
        </TouchableOpacity>
        {<Text style={getStyles(['errorDetails'])}>{errorDescription}</Text>}
      </View>
      {renderAdminModal && <AdminPanel />}
    </>
  );
}

class ErrorBoundary extends Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: null, errorDescription: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorDescription: error };
  }


  componentDidUpdate(prevProps, prevState) {
    const { serviceStatus, setServiceStatus } = this.props;

    if (prevProps.serviceStatus.hasError !== serviceStatus.hasError && serviceStatus.hasError) {
      this.setState({ hasError: true, errorMessage: serviceStatus.errorMessage });
    }

    if (prevState.hasError !== this.state.hasError && !this.state.hasError && serviceStatus.hasError) {
      setServiceStatus({ hasError: false, errorMessage: '', errorDescription: '' });
    }

    if (prevProps.serviceStatus.hasError && !this.props.serviceStatus.hasError) {
      this.setState({ hasError: false, errorMessage: null, errorDescription: null });
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  handleRetry = () => {
    // Resetting state to attempt re-rendering the child components
    this.setState({ hasError: false, errorMessage: null, errorDescription: null });
  };


  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryComp handleRetry={this.handleRetry} errorMessage={this.state.errorMessage?.toString() || ""} errorDescription={this.state.errorDescription?.toString() || ""} />
      );
    }

    return this.props.children;
  }
}

// Connecting to Redux
const mapStateToProps = (state) => ({
  serviceStatus: state.appConfigSlice.serviceStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setServiceStatus }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
